import { Lightning, Router } from "@lightningjs/sdk";
import { Card } from "./Card";
import { FOCUS_TRANSITION } from "./focus";
export class OnNowCard extends Lightning.Component {
    static _template() {
        return {
            w: this.W,
            h: this.H,
            Heading: {
                text: {
                    fontFace: "Roboto",
                    fontStyle: "500",
                    fontSize: 24,
                    lineHeight: 31,
                    h: 31,
                    offsetY: 25,
                    precision: 1,
                },
            },
            Body: {
                y: 44.453,
                w: this.W,
                h: 181,
                rect: true,
                color: 0xff152138,
                shader: { type: Lightning.shaders.RoundedRectangle, radius: 4.722 },
                Title: {
                    x: 26.906,
                    y: 30,
                    text: {
                        fontFace: "Roboto",
                        fontStyle: "500",
                        fontSize: 24,
                        lineHeight: 31,
                        h: 83,
                        offsetY: 25,
                        precision: 1,
                        wordWrapWidth: 449.189,
                        maxLines: 2,
                    },
                },
                Progress: {
                    x: 26.906,
                    y: 124.727,
                    w: 449.189,
                    h: 3.542,
                    rect: true,
                    color: 0x38ffffff,
                    visible: false,
                    Fill: { h: 3.542, rect: true, color: 0xffff77e7 },
                },
                Time: {
                    x: 26.906,
                    y: 134.723,
                    text: {
                        fontFace: "Roboto",
                        fontStyle: "700",
                        fontSize: 19,
                        lineHeight: 24.491,
                        h: 24.491,
                        offsetY: 19,
                        precision: 1,
                    },
                },
                Border: {
                    alpha: 0,
                    color: Card.BORDER_COLOR,
                    texture: Card.borderTexture(this.W, 181, 4.722),
                },
            },
        };
    }
    static get width() {
        return this.W;
    }
    static get height() {
        return this.H;
    }
    static get marginRight() {
        return 20;
    }
    set item(item) {
        var _a, _b;
        this._item = item;
        this.patch({
            Heading: { text: { text: (_a = item.heading) !== null && _a !== void 0 ? _a : "" } },
            Body: {
                Title: { text: { text: item.title } },
                Time: { text: { text: item.time } },
                Progress: {
                    visible: item.progress !== undefined,
                    Fill: { w: 449.189 * Math.max(0, Math.min(1, (_b = item.progress) !== null && _b !== void 0 ? _b : 0)) },
                },
            },
        });
    }
    _focus() {
        this.tag("Body.Border").setSmooth("alpha", 1, FOCUS_TRANSITION);
    }
    _unfocus() {
        this.tag("Body.Border").setSmooth("alpha", 0, FOCUS_TRANSITION);
    }
    _handleEnter() {
        var _a, _b, _c;
        if ((_a = this._item) === null || _a === void 0 ? void 0 : _a.href) {
            Router.navigate("video", {
                href: this._item.href,
                title: this._item.title,
                category: "Ligue 1+ 24/7",
                mode: "linear",
                programmeTime: this._item.time,
                nextTitle: (_b = this._item.next) === null || _b === void 0 ? void 0 : _b.title,
                nextTime: (_c = this._item.next) === null || _c === void 0 ? void 0 : _c.time,
            });
        }
        return true;
    }
}
OnNowCard.W = 503;
OnNowCard.H = 225.453;
export default OnNowCard;
//# sourceMappingURL=OnNowCard.js.map